import React, { CSSProperties } from 'react';

export type BoxProps = {
  children?: React.HTMLAttributes<HTMLDivElement>['children'];
  style?: React.HTMLAttributes<HTMLDivElement>['style'];
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
} & CSSProperties;
const Box = ({ className, children, ...styles }: BoxProps) => {
  return (
    <div className={className} style={styles}>{children}</div>
  );
};

export default Box;
